import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * ProductComponent reads its resolved data as a one-time `ActivatedRoute.snapshot` (not
 * reactively), so Angular's default reuse strategy — which reuses the component instance when
 * navigating between two activations of the same route config, even with a different param —
 * leaves the page showing the previous product while only the URL changes (e.g. clicking from one
 * chat product card straight to another). Disable reuse for just that route; every other route
 * keeps the default behavior.
 */
@Injectable({ providedIn: 'root' })
export class AppRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean {
    return false;
  }

  store(): void {}

  shouldAttach(): boolean {
    return false;
  }

  retrieve(): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig === curr.routeConfig && future.routeConfig?.path === 'product/:slugAndId') {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
